module.exports = __webpack_public_path__ + "components/homepage-hero/static/hero-bg-1920@2x-7a5e61301c14502f8bd35635bd1d9865.webp";